<template>
  <div class="times_container top-left w50 right margin margin_r_hf margin_l_c">
    <times-chart v-if="mainView === 'time_chart'"></times-chart>
  </div>
</template>

<script>
import TimesChart from "../components/TimesChart.component";
import {mapState} from "vuex";

export default {
  name: "GraphTimes.container",
  components: {
    TimesChart
  },
  computed:{
    ...mapState("tasks" , ["chartsViewBlocks"])
  },
  data() {
    return {
      mainView: 'time_chart',
    };
  },
  watch: {
    chartsViewBlocks: function(){
      this.mainView = this.chartsViewBlocks[2];
    }
  }
};
</script>

<style scoped>
.times_container {
  width: 44.8%;
}
.right {
  float: right;
}
.margin {
  /*margin: 0.5rem;*/
}
.margin_r_hf {
  /*margin-right: 0;*/
}
.margin_l_c {
  /*margin-left: 0.2rem;*/
}
.styleCard {
  /*box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);*/
  border-radius: 0px;
  height: 300px;
  font-family: Montserrat;
}
</style>
